import axios from 'axios';

const API_URL ='https://dailyreportsapi.winggs.in/api';
// const API_URL ='http://localhost:5000/api'; // Use this for local development

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { 'x-auth-token': token } : {};
};

const getProjectUrls = async (projectId) => {
  const response = await axios.get(`${API_URL}/projects/${projectId}/urls`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

const addProjectUrl = async (projectId, urlData) => {
  const response = await axios.post(`${API_URL}/projects/${projectId}/urls`, urlData, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

const updateProjectUrl = async (urlId, urlData) => {
  const response = await axios.put(`${API_URL}/urls/${urlId}`, urlData, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

const deleteProjectUrl = async (urlId) => {
  const response = await axios.delete(`${API_URL}/urls/${urlId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

const unblurProjectUrl = async (urlId) => {
  const response = await axios.put(`${API_URL}/urls/${urlId}/unblur`, {}, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

const projectUrlService = {
  getProjectUrls,
  addProjectUrl,
  updateProjectUrl,
  deleteProjectUrl,
  unblurProjectUrl,
};

export default projectUrlService;
